import { Button, Dialog } from "@l30/ui";

import {
  GOP_PORTAL_WELCOME_GUIDE,
  PORTAL_HELP_AREAS,
  PORTAL_HELP_AREAS_HEADING,
  PORTAL_HELP_CONTACT_FALLBACK,
  PORTAL_HELP_CONTACT_HEADING,
  PORTAL_HELP_REPLAY_HINT,
  PORTAL_HELP_REPLAY_LABEL,
  PORTAL_HELP_SIGN_IN_BULLETS,
  PORTAL_HELP_SIGN_IN_HEADING,
  PORTAL_HELP_TITLE,
} from "../../lib/portal-copy.js";

/**
 * Persistent guest Help sheet — plain language, no staff Help / Ask AI.
 *
 * @see docs/superpowers/specs/2026-08-14-portal-novice-help-design.md
 */

export function PortalHelpSheet({
  open,
  onClose,
  onReplayOrientation,
}: {
  open: boolean;
  onClose: () => void;
  onReplayOrientation: () => void;
}) {
  const guide = GOP_PORTAL_WELCOME_GUIDE;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={PORTAL_HELP_TITLE}
      side="right"
      className="max-w-md"
    >
      <div className="space-y-8 text-sm">
        <section className="space-y-3">
          <h3 className="text-base font-semibold text-fg">{guide.heading}</h3>
          <p className="text-fg-muted">{guide.intro}</p>
          {guide.sections.map((section) => (
            <div key={section.title} className="space-y-2">
              <h4 className="font-semibold text-fg">{section.title}</h4>
              <ul className="list-disc space-y-1.5 pl-5 text-fg-muted">
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </div>
          ))}
          <p className="text-fg-subtle">{guide.closing}</p>
        </section>

        <section className="space-y-3 border-t border-border pt-6">
          <h3 className="text-base font-semibold text-fg">{PORTAL_HELP_AREAS_HEADING}</h3>
          <ul className="space-y-3">
            {PORTAL_HELP_AREAS.map((area) => (
              <li key={area.id}>
                <div className="font-medium text-fg">{area.title}</div>
                <p className="mt-0.5 text-fg-muted">{area.description}</p>
              </li>
            ))}
          </ul>
        </section>

        <section className="space-y-3 border-t border-border pt-6">
          <h3 className="text-base font-semibold text-fg">{PORTAL_HELP_SIGN_IN_HEADING}</h3>
          <ul className="list-disc space-y-1.5 pl-5 text-fg-muted">
            {PORTAL_HELP_SIGN_IN_BULLETS.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </section>

        <section className="space-y-3 border-t border-border pt-6">
          <h3 className="text-base font-semibold text-fg">{PORTAL_HELP_REPLAY_LABEL}</h3>
          <p className="text-fg-muted">{PORTAL_HELP_REPLAY_HINT}</p>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={() => {
              onClose();
              onReplayOrientation();
            }}
          >
            {PORTAL_HELP_REPLAY_LABEL}
          </Button>
        </section>

        <section className="space-y-2 border-t border-border pt-6">
          <h3 className="text-base font-semibold text-fg">{PORTAL_HELP_CONTACT_HEADING}</h3>
          <p className="text-fg-muted">{PORTAL_HELP_CONTACT_FALLBACK}</p>
        </section>
      </div>
    </Dialog>
  );
}
